import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { valToPercent } from '../../helpers/value'
import { PopupBuyNow } from '../../userManagement/subscriptionPayment/common/popupBuyNow'
import { PopupBuyPackage } from '../../userManagement/subscriptionPayment/common/popupBuyPackage'
import useGetUserProfile from '../category/useGetUserProfile'
import usePricingPackagesByUserType from '../category/usePricingPackagesByUserType'
import { Element } from '../html/element'
import './i18n'

export const BuyPackage = ({
  fiinGateReportTypeId,
  isTwoLine,
  className,
  disableCallApi,
  buyPackageSpanRef,
  setBuyPackageSpanWidth,
}) => {
  const locale = useSelector((state) => state.i18n.locale)
  const { pricingPackages } = usePricingPackagesByUserType(disableCallApi)
  const { userProfile, loading } = useGetUserProfile()

  const [isOpenBuyPackage, setIsOpenBuyPackage] = useState(false)
  const [isOpenBuyNow, setIsOpenBuyNow] = useState(false)

  useEffect(() => {
    if (buyPackageSpanRef) {
      setBuyPackageSpanWidth(buyPackageSpanRef.current?.clientWidth || 0)
    }
  }, [pricingPackages])

  const getPercentDiscount = () => {
    const packages = pricingPackages
      .filter((item) => item.fiinGateReportTypeId === fiinGateReportTypeId)
      .sort(
        (a, b) =>
          b.discountPercentageByQuantity - a.discountPercentageByQuantity,
      )

    return valToPercent(
      packages[0]?.discountPercentageByQuantity,
      locale,
      false,
      false,
      0,
    )
  }

  const openBuyPackage = () => {
    setIsOpenBuyPackage(true)
  }

  return (
    <div
      className={['dFlex', className].join(' ')}
      style={{ gap: isTwoLine && 4, flexDirection: isTwoLine && 'column' }}
    >
      <div className={'dFlex alignItemsCenter'}>
        <span ref={buyPackageSpanRef}>
          <Translate value="common.buyPackage.USE_PACKAGE_DISCOUNT" />
          &nbsp;
          <span className="fw600">
            <Translate value="common.buyPackage.UP_TO" />
            &nbsp;
            {getPercentDiscount()}.
          </span>
        </span>
      </div>

      <Element>
        <Element
          elementName="span"
          style={{ color: '#2C73E8', marginLeft: !isTwoLine && 3 }}
          onClick={openBuyPackage}
        >
          <Translate
            value="common.buyPackage.BUY_PACKAGE"
            className="cursorPointer"
          />
        </Element>
      </Element>
      {isOpenBuyPackage && (
        <PopupBuyPackage
          isShow={isOpenBuyPackage}
          setIsShow={setIsOpenBuyPackage}
          defaultReportId={fiinGateReportTypeId}
          setIsOpenBuyNow={setIsOpenBuyNow}
          userProfile={userProfile}
          loadingUserProfile={loading}
        />
      )}

      {isOpenBuyNow && (
        <PopupBuyNow
          isShow={isOpenBuyNow}
          setIsShow={setIsOpenBuyNow}
          userProfile={userProfile}
          loadingUserProfile={loading}
          isBuyPackage
        />
      )}
    </div>
  )
}

BuyPackage.propTypes = {
  fiinGateReportTypeId: PropTypes.number.isRequired,
  isTwoLine: PropTypes.bool,
  disableCallApi: PropTypes.bool,
}

BuyPackage.defaultProps = {
  isTwoLine: true,
  disableCallApi: false,
}
